import { useDefaultAssessmentPrompt } from "../../../hooks/useDefaultAssessmentPrompt";

type DefaultAssessmentPromptPrefetchProps = Readonly<{
  conceptCode: string;
  /** Reference Object type → API `target_type`. */
  objectType?: string;
  /**
   * Assessment Template UI label or API code → `assessment_type`
   * (`tagging` | `implementation`).
   */
  assessmentTemplate?: string;
}>;

/** Prefetches default prompt when concept is selected, before the field is shown. */
export default function DefaultAssessmentPromptPrefetch({
  conceptCode,
  objectType,
  assessmentTemplate,
}: DefaultAssessmentPromptPrefetchProps) {
  // `sub_type` is derived from Object type only — never from Value selection.
  useDefaultAssessmentPrompt(conceptCode, {
    targetType: objectType,
    assessmentType: assessmentTemplate,
  });
  return null;
}
